import { useEffect } from 'react';
import { Cloud, CloudOff, RefreshCw } from 'lucide-react';
import { useHybridAnalysisStore } from '../stores/hybridAnalysisStore';
import { cn } from '../utils/cn';

const SyncStatus = () => {
  const { 
    syncStatus, 
    lastSyncTime, 
    syncToCloud, 
    error,
    retrySync,
    localResults,
    cloudResults
  } = useHybridAnalysisStore();

  const unsyncedCount = localResults.length - cloudResults.length;
  const hasUnsynced = unsyncedCount > 0;

  useEffect(() => {
    // 未同期のデータがある場合、30秒ごとに自動同期を試みる
    if (hasUnsynced) {
      const interval = setInterval(() => {
        syncToCloud().catch(console.error);
      }, 30 * 1000);
      return () => clearInterval(interval);
    }
  }, [hasUnsynced, syncToCloud]);

  if (!hasUnsynced && !error) return null;

  return (
    <div className="fixed bottom-4 left-4 max-w-sm">
      <div className={cn(
        "p-4 rounded-lg shadow-lg",
        error ? "bg-red-50" : "bg-blue-50"
      )}>
        <div className="flex items-start space-x-3">
          {error ? (
            <CloudOff className="h-5 w-5 text-red-500 flex-shrink-0 mt-1" />
          ) : syncStatus === 'syncing' ? (
            <RefreshCw className="h-5 w-5 text-blue-500 animate-spin flex-shrink-0 mt-1" />
          ) : (
            <Cloud className="h-5 w-5 text-blue-500 flex-shrink-0 mt-1" />
          )}
          
          <div className="flex-1 min-w-0">
            <p className={cn(
              "text-sm font-medium",
              error ? "text-red-800" : "text-blue-800"
            )}>
              {error ? 'クラウドとの同期に失敗しました' : 
               syncStatus === 'syncing' ? 'クラウドと同期中...' :
               `未同期のデータが${unsyncedCount}件あります`}
            </p>
            {error && (
              <p className="text-xs text-red-600 mt-1 break-words">
                {error}
              </p>
            )}
            {lastSyncTime && !error && (
              <p className="text-xs text-blue-600 mt-1">
                最終同期: {new Date(lastSyncTime).toLocaleString()}
              </p>
            )}
          </div>

          {(error || (syncStatus !== 'syncing' && hasUnsynced)) && (
            <button
              onClick={() => error ? retrySync() : syncToCloud()}
              className={cn(
                "btn btn-sm",
                error ? "btn-error" : "btn-primary"
              )}
              disabled={syncStatus === 'syncing'}
            >
              {error ? '再試行' : '今すぐ同期'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SyncStatus;